import { render } from "./WebShopKasse.vue?vue&type=template&id=613aebb0&scoped=true&ts=true"
import script from "./WebShopKasse.vue?vue&type=script&lang=ts"
export * from "./WebShopKasse.vue?vue&type=script&lang=ts"

import "./WebShopKasse.vue?vue&type=style&index=0&id=613aebb0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613aebb0"]])

export default __exports__